module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_axios@0.21.4@axios/index.js
// module id = yzkn
// module chunks = 16